import React, {useContext, useEffect, useState} from "react";
import {EventIntf} from "../ServerTypes";
import {useParams} from "react-router-dom";
import {MessageContext} from "../../MessageContext";
import EventAdminNav from "./EventAdminNav";
import {Button, Typography} from "@material-ui/core";
import {EventBriteFetcher} from "../EventBriteHelper";



export default function EventEventBrite() {
    const messageContext = useContext(MessageContext)

    const {eventId} = useParams()

    const [event, setEvent] = useState<EventIntf | null>(null)
    const [ebToken, setEbToken] = useState<string | null>(null)
    const [totalAttendees, setTotalAttendees] = useState(0)


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(event => {
                setEvent(event)
            })
    }, [])

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/user-eventbrite-token`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(response => {
                    setEbToken(response.eventbrite_token)
                }
            )
    }, [])

    useEffect(() => {
        if (event) {
            //eb-attendees-attendee-count
            let ebUrl = `${process.env.REACT_APP_API_CALL}/eb-attendees-attendee-count/${event.eventbrite_id}`

            fetch(ebUrl, {
                headers: new Headers({
                    'Authorization': 'Bearer ' + ebToken
                })
            })
                .then(response => response.json())
                .then(response => {
                    setTotalAttendees(response.total)
                    }
                )
        }
    }, [event])

    const sendAttendeesToServer = (eb_event_id: string, attendees: any, continuation: string) => {
        fetch(`${process.env.REACT_APP_API_CALL}/eb-attendees-batch-upload`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                attendees: attendees,
                eb_event_id: eb_event_id
            })
        })
            .then(response => {
                if (response.status >= 400) {
                    messageContext.showErrorMessage("Server error. Please try again.")
                } else {
                    return response.json()
                }
            })
            .then(response => {
                if (continuation) {
                    loadAttendeeInfo(continuation)
                } else {
                    messageContext.showSuccessMessage("Attendees uploaded.")
                }
                setTotalAttendees(response.total)
            })
    }

    const loadAttendeeInfo = (continuation: string | null) => {
        if (event) {
            let ebUrl = `https://www.eventbriteapi.com/v3/events/${event.eventbrite_id}/attendees/`

            if(continuation){
                ebUrl = ebUrl + `?continuation=${continuation}`
            }

            fetch(ebUrl, {
                headers: new Headers({
                    'Authorization': 'Bearer ' + ebToken
                })
            })
                .then(response => response.json())
                .then(response => {
                        console.log("response", response)

                        const attendees = response.attendees.map((att: any) => {
                            return {id: att.id, email: att.profile.email}
                        })

                        sendAttendeesToServer(event.eventbrite_id!, attendees, response.pagination.continuation)
                    }
                )
        }
    }



    return event ? <>
        <div className="manage-events-body">
            <div>
                <EventAdminNav event={event}/>
            </div>
            <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => loadAttendeeInfo(null)}
            >
                Refresh Attendees
            </Button>

            <Typography variant='h2'>Attendee Count: {totalAttendees}</Typography>

        </div>
    </> : <></>
}
